/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'coin': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M0 0h20v20H0z"/><ellipse pid="1" _stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" cx="9.673" cy="6.164" rx="6.673" ry="3.164"/><path pid="2" d="M4.257 8.09C3.467 8.61 3 9.25 3 9.94c0 1.746 2.988 3.163 6.673 3.163s6.673-1.417 6.673-3.164c0-.73-.522-1.403-1.4-1.939" _stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/><path pid="3" d="M4.257 12.09C3.467 12.61 3 13.25 3 13.94c0 1.746 2.988 3.163 6.673 3.163s6.673-1.417 6.673-3.164c0-.73-.522-1.403-1.4-1.939" _stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/></g>'
  }
})
